import { render, staticRenderFns } from "./Adjustments.vue?vue&type=template&id=2d723d96&scoped=true&"
import script from "./Adjustments.vue?vue&type=script&lang=js&"
export * from "./Adjustments.vue?vue&type=script&lang=js&"
import style0 from "./Adjustments.vue?vue&type=style&index=0&id=2d723d96&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d723d96",
  null
  
)

export default component.exports